// REGULATORY DNA: Static Imports from the src directory
import trialStatusData from "../data/list_values/entities/overall_trial_status.json";
import allocationData from "../data/list_values/entities/clinical_trial_allocation_method.json";
import groupData from "../data/list_values/entities/clinical_trial_group.json";
import scopeData from "../data/list_values/entities/clinical_trial_scope.json";
import phaseData from "../data/list_values/entities/clinical_trial_type_phase.json";
import productCharData from "../data/list_values/entities/medicinal_product_characteristics.json";
import sponsorDutiesData from "../data/list_values/entities/sponsor_trial_duties.json";
import ageRangeData from "../data/list_values/entities/subject_age_range.json";
import therapeuticAreaData from "../data/list_values/entities/therapeutic_area.json";
import trialCategoryData from "../data/list_values/entities/trial_category.json";
import deviceTypeData from "../data/list_values/entities/type_of_device.json";

/**
 * Helper: Normalizes the EMA JSON structure into a flat array of labels.
 * This targets the 'react.options' path found in your entity files.
 */
const extractLabels = (jsonData) => {
  if (!jsonData?.react?.options) return [];
  return jsonData.react.options
    .map(opt => opt.label)
    .filter(label => label !== null && label !== undefined);
};

// EXPORTED CONSTANTS: The source of truth for the Controller and View
export const REGULATORY_DATA = {
  STATUSES: extractLabels(trialStatusData), //
  ALLOCATION: extractLabels(allocationData), //
  GROUPS: extractLabels(groupData), //
  SCOPES: extractLabels(scopeData), //
  PHASES: extractLabels(phaseData), //
  CHARACTERISTICS: extractLabels(productCharData), //
  DUTIES: extractLabels(sponsorDutiesData), //
  AGE_RANGES: extractLabels(ageRangeData), //
  THERAPEUTIC_AREAS: extractLabels(therapeuticAreaData), //
  TRIAL_CATEGORIES: extractLabels(trialCategoryData), //
  DEVICE_TYPES: extractLabels(deviceTypeData) //
};

/**
 * Initial empty registry ensures no hardcoded projects exist upon load.
 */
export const emptyProjectRegistry = [];